import L from "leaflet";
import 'leaflet.markercluster';
import KeyPopup from './keyPopup';
import Help from './Help';
export function getResponsiveKey(mapInstance) {
    let isFullScreen = false;
    let keyPopup = null;
    let fullScreenPopup;
    function showFullScreenKey() {
        //console.log("Add full sized called");
        document.body.style.overflowY = "hidden";
        document.documentElement.style.overflowY = "hidden";
        fullScreenPopup = document.getElementById("fullscreen-popup");
        let fullScreenPopupContent = document.getElementById("fullscreen-popup-content");
        fullScreenPopupContent.innerHTML = KeyPopup.createPopup();
        fullScreenPopup.classList.add("visible");
        const closeButton = fullScreenPopup.querySelector('.close-btn'); //document.getElementById("key-popup-close-btn")!
        if (!Help.isNullOrUndef(closeButton) && closeButton !== null)
            closeButton.addEventListener('click', function () {
                //console.log(`vanilla event listener`)
                fullScreenPopupContent.innerHTML = "";
                document.body.style.removeProperty("overflow-y");
                document.documentElement.style.removeProperty("overflow-y");
                closeBoth();
            }, { once: true });
        //else
        //	console.log(`CANT ADD vanilla event listener NULL`)
    }
    function removeKeyPopup() {
        //console.log("removeKeyPopup");
        keyPopup.remove();
        keyPopup = null;
    }
    function hideFullScreenPopup() {
        fullScreenPopup.classList.remove("visible");
    }
    function closeBoth() {
        //console.log("Close called");
        if (keyPopup) {
            //console.log("removing key");
            removeKeyPopup();
        }
        if (isFullScreen) {
            //console.log("removing Full Screen");
            hideFullScreenPopup();
        }
    }
    //icon for keys 
    L.Control.Toggler = L.Control.extend({
        onAdd: function (map) {
            //console.log("toggler added");
            var toggleButton = L.DomUtil.create('button');
            toggleButton.className = "btn_key";
            toggleButton.title = "Our Accreditations";
            toggleButton.onclick = function (event) {
                event.preventDefault();
                event.stopPropagation();
                if (!Help.isNullOrEmpty(keyPopup)) {
                    removeKeyPopup();
                }
                else {
                    if (Help.isNarrowOrShortIsMobileDevice()) { //new fullscreen
                        isFullScreen = true;
                        showFullScreenKey();
                    }
                    else { //original inline
                        isFullScreen = false;
                        keyPopup = L.control.keyPopup({ position: 'topleft' });
                        keyPopup.addTo(map);
                    }
                }
                return false;
            };
            L.DomEvent.addListener(toggleButton, 'mousedown dblclick', function (e) { L.DomEvent.stopPropagation(e); }); //stops double click from => zoom map
            return toggleButton;
        },
        onRemove: function (map) { } // Nothing to do here 
    });
    L.control.toggler = function (opts) { return new L.Control.Toggler(opts); };
    L.control.toggler({ position: 'topleft' }).addTo(mapInstance);
    mapInstance.on('click', function (event) {
        if (!Help.isNullOrEmpty(keyPopup) && !event.originalEvent.target.closest('.key-popup-container')
            && !event.originalEvent.target.closest('.btn_key')) {
            removeKeyPopup();
        }
    });
    //creates the popup (clicking our icon btn) 
    L.Control.KeyPopup = L.Control.extend({
        onAdd: function (map) {
            //console.log("Add key called");
            var container = L.DomUtil.create('div', 'key-popup-container');
            container.innerHTML = KeyPopup.createPopup();
            L.DomEvent.on(container, 'mousedown dblclick', function (e) {
                L.DomEvent.stopPropagation(e);
            });
            const closeButton = container.querySelector('.close-btn'); //<a class="leaflet-popup-close-button" href="#close" style="outline: none;">�</a>
            if (closeButton !== null)
                L.DomEvent.on(closeButton, 'click', function () { closeBoth(); });
            //else
            //	console.log(`CANT ADD mobile / leaflet event listener NULL`)
            return container;
        },
        onRemove: function (map) { } // Nothing to do here
    });
    L.control.keyPopup = function (opts) { return new L.Control.KeyPopup(opts); };
}
